import CONST from './Constant';
import axiosPrivate from '../../../../Setup/Axios/SetupAxios';
import { handleAsyncAction } from "../../../../Setup";

export const setConfig = (payload) => ({
    type: CONST.SET_CONFIG,
    payload,
});

export const setSelectedRoster = (payload) => ({
    type: CONST.SET_SELECTED_ITEM,
    payload: payload
});

export const fetchRosterStatsSuccess = (payload) => ({
    type: CONST.FETCH_ROSTER_STATS_SUCCESS,
    payload: payload
});
export const fetchRosterStatsFailed = (payload) => ({
    type: CONST.FETCH_ROSTER_STATS_FAILED,
    payload: payload
});
export const fetchRosterStats = ({dispatch, filters}) => {
    return handleAsyncAction(
        dispatch,
        () => axiosPrivate.get('roster/rosters/stats', { params: filters }),
        [fetchRosterStatsSuccess],
        [fetchRosterStatsFailed]
    );
}

/*****************************************************
 * Fetch Roster
 ****************************************************/
export const fetchRosterSuccess = (payload) => ({
    type: CONST.FETCH_ITEM_SUCCESS,
    payload: payload
});

export const fetchRosterFailed = (payload) => ({
    type: CONST.FETCH_ITEM_FAILED,
    payload: payload
});

export const fetchRoster = ({dispatch, filters}) => {
    return handleAsyncAction(
        dispatch,
        () => axiosPrivate.get(`roster/rosters/${filters['id']}`, {params: filters}),
        [fetchRosterSuccess],
        [fetchRosterFailed]
    );
};

export const fetchCurrentRoster = ({dispatch}) => {
    return handleAsyncAction(
        dispatch,
        () => axiosPrivate.get(`roster/rosters/current`,),
        [fetchRosterSuccess],
        [fetchRosterFailed]
    );
};

/*****************************************************
 * Fetch Roster
 ****************************************************/
export const fetchRostersSuccess = (payload) => ({
    type: CONST.FETCH_ITEMS_SUCCESS,
    payload: payload
});

export const fetchRostersFailed = (payload) => ({
    type: CONST.FETCH_ITEMS_FAILED,
    payload: payload
});

export const fetchRosters = ({dispatch, filters}) => {
    return handleAsyncAction(
        dispatch,
        () => axiosPrivate.get('roster/rosters', { params: filters }),
        [fetchRostersSuccess],
        [fetchRostersFailed]
    );
};

/*****************************************************
 * Add Roster
 ****************************************************/
export const addRosterSuccess = (payload) => ({
    type: CONST.ADD_ITEM_SUCCESS,
    payload: payload
});

export const addRosterFailed = (payload) => ({
    type: CONST.ADD_ITEM_FAILED,
    payload: payload
});

export const addRoster = ({dispatch, data}) => {
    return handleAsyncAction(
        dispatch,
        () => axiosPrivate.post('roster/rosters', data),
        [addRosterSuccess],
        [addRosterFailed]
    );
};

/*****************************************************
 * Update Roster
 ****************************************************/
export const updateRosterSuccess = (payload) => ({
    type: CONST.UPDATE_ITEM_SUCCESS,
    payload: payload
});

export const updateRosterFailed = (payload) => ({
    type: CONST.UPDATE_ITEM_FAILED,
    payload: payload
});

export const updateRoster = ({dispatch, data}) => {
    return handleAsyncAction(
        dispatch,
        () => axiosPrivate.patch(`roster/rosters/${data['id']}`, data),
        [updateRosterSuccess],
        [updateRosterFailed]
    );
};

/*****************************************************
 * Delete Roster
 ****************************************************/
export const deleteRosterSuccess = (payload) => ({
    type: CONST.DELETE_ITEM_SUCCESS,
    payload: payload
});

export const deleteRosterFailed = (payload) => ({
    type: CONST.DELETE_ITEM_FAILED,
    payload: payload
});

export const deleteRoster = ({dispatch, data}) => {
    return handleAsyncAction(
        dispatch,
        () => axiosPrivate.delete(`roster/rosters/${data['id']}`),
        [deleteRosterSuccess],
        [deleteRosterFailed]
    );
};



/*****************************************************
 * Fetch Roster
 ****************************************************/
export const fetchRosterEntrySuccess = (payload) => ({
    type: CONST.FETCH_ITEM_SUCCESS,
    payload: payload
});

export const fetchRosterEntryFailed = (payload) => ({
    type: CONST.FETCH_ITEM_FAILED,
    payload: payload
});

export const fetchRosterEntry = ({dispatch, filters}) => {
    return handleAsyncAction(
        dispatch,
        () => axiosPrivate.get(`roster/roster-entries/${filters['id']}`, {params: filters}),
        [fetchRosterEntrySuccess],
        [fetchRosterEntryFailed]
    );
};

/*****************************************************
 * Fetch Roster
 ****************************************************/
export const fetchRosterEntriesSuccess = (payload) => ({
    type: CONST.FETCH_ITEMS_SUCCESS,
    payload: payload
});

export const fetchRosterEntriesFailed = (payload) => ({
    type: CONST.FETCH_ITEMS_FAILED,
    payload: payload
});

export const fetchRosterEntries = ({dispatch, filters}) => {
    return handleAsyncAction(
        dispatch,
        () => axiosPrivate.get('roster/roster-entries', { params: filters }),
        [fetchRosterEntriesSuccess],
        [fetchRosterEntriesFailed]
    );
};

/*****************************************************
 * Add Roster
 ****************************************************/
export const addRosterEntrySuccess = (payload) => ({
    type: CONST.ADD_ITEM_SUCCESS,
    payload: payload
});

export const addRosterEntryFailed = (payload) => ({
    type: CONST.ADD_ITEM_FAILED,
    payload: payload
});

export const addRosterEntry = ({dispatch, data}) => {
    return handleAsyncAction(
        dispatch,
        () => axiosPrivate.post('roster/roster-entries', data),
        [addRosterEntrySuccess],
        [addRosterEntryFailed]
    );
};

/*****************************************************
 * Update Roster
 ****************************************************/
export const updateRosterEntrySuccess = (payload) => ({
    type: CONST.UPDATE_ITEM_SUCCESS,
    payload: payload
});

export const updateRosterEntryFailed = (payload) => ({
    type: CONST.UPDATE_ITEM_FAILED,
    payload: payload
});

export const updateRosterEntry = ({dispatch, data}) => {
    return handleAsyncAction(
        dispatch,
        () => axiosPrivate.patch(`roster/roster-entries/${data['id']}`, data),
        [updateRosterEntrySuccess],
        [updateRosterEntryFailed]
    );
};

/*****************************************************
 * Delete Roster
 ****************************************************/
export const deleteRosterEntrySuccess = (payload) => ({
    type: CONST.DELETE_ITEM_SUCCESS,
    payload: payload
});

export const deleteRosterEntryFailed = (payload) => ({
    type: CONST.DELETE_ITEM_FAILED,
    payload: payload
});

export const deleteRosterEntry = ({dispatch, data}) => {
    return handleAsyncAction(
        dispatch,
        () => axiosPrivate.delete(`roster/roster-entries/${data['id']}`),
        [deleteRosterEntrySuccess],
        [deleteRosterEntryFailed]
    );
};



/*****************************************************
 Roster Calendar
****************************************************/
export const setConfigCalendar = (payload) => ({
    type: CONST.SET_CONFIG_CALENDAR,
    payload,
});

export const fetchRosterCalendarSuccess = (payload) => ({
    type: CONST.FETCH_ROSTER_CALENDAR_SUCCESS,
    payload: payload
});

export const fetchRosterCalendarFailed = (payload) => ({
    type: CONST.FETCH_ROSTER_CALENDAR_FAILED,
    payload: payload
});

export const fetchRosterCalendar = ({dispatch, filters}) => {
    return handleAsyncAction(
        dispatch,
        () => axiosPrivate.get('roster/roster-entries/calendar', { params: filters }),
        [fetchRosterCalendarSuccess],
        [fetchRosterCalendarFailed]
    );
};

/*****************************************************
 Lock Roster & Generate PDF
****************************************************/

export const lockRoster = ({dispatch, data}) => {
    return handleAsyncAction(
        dispatch,
        () => axiosPrivate.post('roster/rosters/lock', data),
        [fetchRosterSuccess],
        [fetchRosterFailed]
    );
};

/*****************************************************
 Retry PDF Generation
****************************************************/

export const retryPDFGeneration = ({dispatch, data}) => {
    return handleAsyncAction(
        dispatch,
        () => axiosPrivate.post('roster/rosters/retry-pdf-generation', data),
        [],
        []
    );
};


/*****************************************************
 Check PDF Status
****************************************************/
export const checkPDFStatusSuccess = (payload) => ({
    type: CONST.CHECK_PDF_STATUS_SUCCESS,
    payload: payload
});

export const checkPDFStatusFailed = (payload) => ({
    type: CONST.CHECK_PDF_STATUS_FAILED,
    payload: payload
}); 

export const checkPDFStatus = ({dispatch, data}) => {
    return handleAsyncAction(
        dispatch,
        () => axiosPrivate.get('roster/roster-entries/pdf-status', { params: data }),
        [checkPDFStatusSuccess],
        [checkPDFStatusFailed]
    );
};

